import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromCalendarActions from 'src/app/state-management/actions/calendar.actions';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  destroyed$: Subject<any> = new Subject<any>();
  data$: Observable<IDashboardState>;
  data: IDashboardState;
  constructor(private store: Store<IAumyeState>) {
    this.data$ = this.store.select('aumyeDashboardState');
    this.data$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.data = data;
    });
  }
  date: Date = new Date();
  ngOnInit(): void {
    this.store.dispatch(new fromCalendarActions.InitVisitorCalendar(this.data));
  }
}
